import { FC } from 'react';

import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { setIsCampaignInsufficientBalanceAlertVisible } from 'store/models/campaignsDashboard';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'CampaignInsufficientBalanceAlert.title',
    description: 'CampaignInsufficientBalanceAlert.description',
    topupBalance: 'CampaignInsufficientBalanceAlert.button.topupBalance',
    cancel: 'CampaignInsufficientBalanceAlert.button.cancel',
};

export const CampaignInsufficientBalanceAlert: FC<{ setIsBalanceReplenishmentModalVisibleOn: () => void }> = ({
    setIsBalanceReplenishmentModalVisibleOn,
}) => {
    const isAlertVisible = useSelector((state) => state.campaignsDashboard.isCampaignInsufficientBalanceAlertVisible);

    const dispatch = useDispatch();
    const trls = useTrls();

    const handleClose = () => dispatch(setIsCampaignInsufficientBalanceAlertVisible(false));

    const handleTopUpButtonClick = () => {
        setIsBalanceReplenishmentModalVisibleOn();
        handleClose();
    };

    return (
        <Alert
            visible={isAlertVisible}
            title={trls(TrlKeys.title)}
            description={trls(TrlKeys.description)}
            buttons={
                <ButtonStack stretched layout="vertical">
                    <Button mode="primary" style="accent" size="small" onClick={handleTopUpButtonClick}>
                        {trls(TrlKeys.topupBalance)}
                    </Button>
                    <Button mode="secondary" style="accent" onClick={handleClose}>
                        {trls(TrlKeys.cancel)}
                    </Button>
                </ButtonStack>
            }
            onClose={handleClose}
        >
            <InfoCircleFilledSize24
                initialColor="tertiary"
                backgroundStyle="secondary"
                padding={12}
                borderRadius="halfHeight"
            />
        </Alert>
    );
};
